import styled from "styled-components";

export const Container = styled.div`
  width: 95%;
  margin: 0 auto;
  background: #ffffff;

  @media (min-width: 1600px) {
    max-width: 1520px;
  }

  @media (min-width: 1360px) and (max-width: 1600px) {
    max-width: 1320px;
  }

  @media (max-width: 1360px) {
    max-width: 1100px;
  }
`;

export const SearchBarBox = styled.div`
  width:95%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* padding:; */

  @media (min-width: 1600px) {
    max-width: 1520px;
  }

  @media (min-width: 1360px) and (max-width: 1600px) {
    max-width: 1320px;
  }

  @media (max-width: 1360px) {
    max-width: 1100px;
  }

`;

export const PeriodContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  fieldset {
    margin-right: 16px;
    border: none;
    input{
      padding: .6rem 1rem;

    }
  }

  label {
    margin-right: 5px;
  }

`;


export const SearchButton = styled.button`
  display: grid;
  padding: .6rem 1rem;
  font-size: 16px;
  align-items: center;
  justify-content: center;
`;


  export const Cards = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  margin: 1rem auto;
  width: 90%;
  border: solid 1px #ccc;
  padding: 1rem;
`;
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30%;
  margin: 1rem auto;
  border: solid 1px #ccc;
  padding: 1rem;
  transition: var(--transition);
  `;

export const ContainerLoading = styled.div`
width: 100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background: #fff;
`;

export const Loader = styled.div`
animation: spin 1s infinite linear;
border: solid ${props => (props.size === 'big' ? '1vmin' : '0.5vmin')}
  transparent;
border-radius: 50%;
border-right-color: ${props =>
  props.color ? props.color : 'var(--color-primary)'};
border-top-color: ${props =>
  props.color ? props.color : 'var(--color-primary)'};
box-sizing: border-box;
height: ${props =>
  props.width ? props.width : props.size === 'big' ? '10vmin' : '5vmin'};
width: ${props =>
  props.width ? props.width : props.size === 'big' ? '10vmin' : '5vmin'};
z-index: 1;
`;
